<template>
    <ui-container class="space-y-8 py-8">

        <!-- Header. -->
        <ui-header :title="item.name" :subtitle="item.reference">
            <template #actions>
                <ui-button-new icon="fas fa-pencil" @click="edit()">Edit</ui-button-new>
                <ui-button-new icon="fas fa-trash" danger @click="openDeleteModal">Delete</ui-button-new>
            </template>
        </ui-header>

        <ui-tabs active="overview" :tabs="tabs" #default="{ isActive }">
            <!-- Overview. -->
            <ui-data-grid v-if="isActive('overview')">
                <ui-data-grid-item label="Name" :value="item.name"></ui-data-grid-item>
                <ui-data-grid-item label="Reference" :value="item.reference"></ui-data-grid-item>
                <ui-data-grid-item wide label="Description" :value="item.description"></ui-data-grid-item>
            </ui-data-grid>

            <!-- Usages Log. -->
            <div v-else-if="isActive('usages_log')">
                <ui-data-grid>
                    <ui-data-grid-item wide label="Log New Usage">
                        <assets-keys-usage-form :item="item"></assets-keys-usage-form>
                    </ui-data-grid-item>
                    <ui-data-grid-item wide label="Usages Log" :key="`${item.id}-keyusage-${(item.usages.data || []).length}-${item.in_use}`">
                        <ui-mini-crud :fetch="() => (item.usages.data || [])" empty-state-text="This key has not yet been used. Use the form above to create a new log entry.">
                            <template #show="{ item }">
                                <ui-mini-crud-card
                                    :title="`Out: ${item.out}${item.in ? (' → In: ' + item.in) : ''}`"
                                    :subtitle="item.contact_name"
                                ></ui-mini-crud-card>
                            </template>
                        </ui-mini-crud>
                    </ui-data-grid-item>
                </ui-data-grid>
            </div>

            <!-- Files. -->
            <div v-else-if="isActive('files')">
                <filesystem
                    compact="true"
                    :filesystem-id="item.filesystem_id"
                ></filesystem>
            </div>
        </ui-tabs>

    </ui-container>
</template>

<script>
export default {
    props: {
        item: Object,
        edit: Function,
        removeItem: Function,
    },
    data () {
        return {
            tabs: [
                { value: 'overview', label: 'Overview' },
                { value: 'usages_log', label: 'Usages Log' },
                { value: 'files', label: 'Files' },
            ],
        }
    },
    methods: {
        openDeleteModal () {
            const title = 'Are you sure you want to delete "' + this.item.name + '"?'
            const description = 'Deleting this key is irreversible. Are you sure you want to delete it?'
            eventBus.$emit('delete-modal-open', title, description, async () => {
                await this.item.delete()
                this.removeItem(this.item)

            });
        },
    },
}
</script>
